import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { ShiftRecipe } from "@models/QontactPoint";
import { buildURL, SystemURL } from "./URLCatalog";

export interface DedicatedShiftRecipePayload
    extends Omit<ShiftRecipe, "buildingID" | "functionalUnitID"> {}

export class UserDedicatedShiftsService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async getShiftRecipesForUser(orgId: string, userId: string): Promise<ShiftRecipe[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.UserDedicatedShifts.getRecipes, {
            org_id: orgId,
            user_id: userId,
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result as ShiftRecipe[];
    }

    async createShiftRecipe(
        orgId: string,
        userId: string,
        recipeData: DedicatedShiftRecipePayload
    ): Promise<string> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.UserDedicatedShifts.postCreateRecipe, {
            org_id: orgId,
            user_id: userId,
        });
        request.method = "POST";
        request.body = recipeData;

        const response = await this.httpClient.execute(request);
        return response.result as string;
    }

    async updateShiftRecipe(
        orgId: string,
        userId: string,
        recipeId: string,
        recipeData: DedicatedShiftRecipePayload
    ): Promise<string> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.UserDedicatedShifts.postUpdateRecipe, {
            org_id: orgId,
            user_id: userId,
            recipe_id: recipeId,
        });
        request.method = "POST";
        request.body = recipeData;

        const response = await this.httpClient.execute(request);
        return response.result as string;
    }

    async deleteShiftRecipe(orgId: string, userId: string, recipeId: string): Promise<string> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.UserDedicatedShifts.deleteRecipe, {
            org_id: orgId,
            user_id: userId,
            recipe_id: recipeId,
        });
        request.method = "DELETE";

        const response = await this.httpClient.execute(request);
        return response.result as string;
    }
}
